<app-tabla
  [totalCount]="totalCount"
  [datos]="datos"
  [columnas]="columnas"
  [name]="name"
  [busquedaLocal]="{ placeholder: 'Buscar solicitante' }"
  [paginatorArriba]="false"
  [paginatorAbajo]="false"
  [showHijos]="false"
  [crear]="botonCrear"
  [emptyState]="{
    title: 'Sin solicitantes',
    subtitle:
      'Agregá los solicitantes habituales para elegirlos rápido al registrar una emergencia.',
  }"
></app-tabla>
